export enum OrderStatus {
  Open = 'Open',
  OpenPending = 'Open, Pending',
  OpenSubmitted = 'Open, Submitted',
  OpenFailed = 'Open, Failed',
  OpenLinksSent = 'Open, Links Sent',
  OpenAllPreviewed = 'Open, All Previewed',
  OpenAllSigned = 'Open, All Signed',
  OpenEligible = 'Open, Eligible',
  OpenNotEligible = 'Open, Not Eligible',
  Archived = 'Archived',
  ArchivedPending = 'Archived, Pending',
  ArchivedLinksSent = 'Archived, Links Sent',
  ArchivedAllPreviewed = 'Archived, All Previewed',
  ArchivedAllSigned = 'Archived, All Signed',
  Canceled = 'Canceled',
  Failed = 'Failed',
}

export enum OrderSummaryStatus {
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Failed = 'Failed',
  NotDefined = 'Not Defined',
  Canceled = 'Canceled',
}
